import axios from './axios';

// Routes History Reports (Legacy)
export const getReportApi = payload =>
  axios.post('transportation/routes/active/history/export', payload, {
    responseType: 'blob',
  });

export const getReportStudentsApi = payload =>
  axios.post('transportation/routes/active/history/exportstudents', payload, {
    responseType: 'blob',
  });

export const getHistoryReportsListApi = () =>
  axios.get('transportation/routes/active/history/reports');

export const getHistoryReportByTypeApi = (reportType, payload) =>
  axios.post(`transportation/routes/active/history/reports/${reportType}`, payload, {
    responseType: 'blob',
  });

// ECA History Reports
export const getEcaHistoryReportsListApi = () =>
  axios.get('eca/events/history/reports');

export const getEcaHistoryReportByTypeApi = (reportType, payload) =>
  axios.post(`eca/events/history/reports/${reportType}`, payload, {
    responseType: 'blob',
  });
